import { render, staticRenderFns } from "./instockDetailDialog.vue?vue&type=template&id=01e6267c&scoped=true&"
import script from "./instockDetailDialog.vue?vue&type=script&lang=js&"
export * from "./instockDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e6267c",
  null
  
)

export default component.exports